import React, { useEffect, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import './Modal.css'; 

const Modal = ({ cont, displayArr, prod, isOpen, msg, txt, title, msgpr, dong, closeModal, closeLimpiaModal, onYes, fetch, depto, porcentaje, contList, isOpenCRG}) => {
      
const componentRef = useRef(null);
  useEffect(() => {

    const handleClickOutside = (event) => {
      if (componentRef.current && !componentRef.current.contains(event.target)) {
        closeModal();
      }
    };
    const handleKeyDown = (event) => {
      // Check if the pressed key is 'Escape'
      if (event.key === 'Escape') {
        closeModal(); // Call the function to close the component
      }
    };

    // Add the event listener when the component mounts or when `isOpen` becomes true
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    }

    // Clean up the event listener when the component unmounts or `isOpen` becomes false
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, closeModal]);

    if (!isOpen) return null;
    console.log("txt: ", txt);
    console.log("msg: ", msg);


//console.log("dong: ", dong);
//console.log("displayArr", displayArr);

switch (txt) {
case "imagen":
    return (
        <div className="modal2">
            <div className="popup">
                <div ref={componentRef} className="popup-inner">
                    <img src={msg} className="img-responsive" alt={title} />
                <AiOutlineClose
                    className="close-icon"
                    size={20}
                    color="#000"
                    onClick={closeModal}
                    cursor={"pointer"}
                />
                <div className="dist-bton">
                </div>
                </div>
            </div>
        </div>
);
case "seguro":
    return (
        <div className="modal">
            <div className="popup">
                <div className="popup-inner">
                    <p className="modal-text">
                    {msg === "seguroelimprod" && <>Está seguro desea eliminar este producto?</>}
                    {msg === "seguroelimcont" && <>Está seguro desea eliminar este controlador?</>}
                    {msg === "seguroelimuser" && <>Está seguro desea eliminar este usuario?</>}
                    {msg === "seguroelimdong" && <>Está seguro desea eliminar este dongle?</>}
                    {msg === "seguroelimpromo" && <>Está seguro desea eliminar esta promoción?</>}
                    {(msg === "segurovincprod" && displayArr.length !== 0) && <>Esta seguro desea vincular el/los display(s) <span className="fw-8">{displayArr.toString()}</span> del controlador <span className="fw-8">{cont}</span> con el producto <span className="fw-8">{prod}</span>?</>}
                    {(msg === "segurovinccont" && displayArr.length !== 0) && <>Esta seguro desea vincular el producto <span className="fw-8">{prod}</span> con el/los display(s) <span className="fw-8">{displayArr.toString()}</span> del controlador <span className="fw-8">{cont.host_esp}</span>?</>}
                    {msg === "seguropromodepto" && <>Esta seguro desea generar la promocion del departamento de <span className="fw-8">{depto}</span> con el descuento del <span className="fw-8">{porcentaje}</span> %?</>}
                    {msg === "segurovincdong" && <>Esta seguro desea vincular el producto <span className="fw-8">{prod}</span> con el dongle <span className="fw-8">{dong}</span>?</>}
                    {(msg === "segurovincprod" || msg === "segurovinccont") && displayArr.length === 0 && <>Agregue un display a la lista</>}
                    {msg === "noselec" && <>No ha seleccionado nada</>}
                <AiOutlineClose
                    className="close-icon"
                    size={20}
                    color="#000"
                    onClick={closeModal}
                    cursor={"pointer"}
                /></p>
                <div className="dist-bton">
{((msg === "seguroelimcont") || (msg === "seguroelimprod") || (msg === "seguroelimuser") || (msg === "seguroelimdong" && dong !== "Seleccionar dongle") || (msg === "segurovincdong" && dong !== "Seleccionar dongle") || (msg === "segurovincprod" && displayArr.length !== 0) || (msg === "segurovinccont" && displayArr.length !== 0) || (msg === "seguropromodepto") || (msg === "seguroelimpromo")) && <button className="bton-modal" onClick={onYes} >Si</button>}
{((msg === "seguroelimcont") || (msg === "seguroelimprod") || (msg === "seguroelimuser") || (msg === "seguroelimdong" && dong !== "Seleccionar dongle") || (msg === "segurovincdong" && dong !== "Seleccionar dongle") || (msg === "segurovincprod" && displayArr.length !== 0) || (msg === "segurovinccont" && displayArr.length !== 0) || (msg === "seguropromodepto") || (msg === "seguroelimpromo")) && <button className="bton-modal" onClick={closeModal}>No</button>}
{(msg === "noselec" || (msg === "segurovincprod" && displayArr.length === 0) || (msg === "segurovinccont" && displayArr.length === 0)) &&  <button className="bton-modal" onClick={closeModal}>Cerrar</button>}
                </div>
                </div>
            </div>
        </div>
);
case "ok":
    return (
        <div className="modal1">
            <div className="popup1">
                <div className="popup-inner1">
                    <p className="modal-text">
                {msg === "okagrprod" && <>El producto se agregó correctamente</>}
                {msg === "okeditprod" && <>El producto se editó correctamente</>}
                {msg === "okelimprod" && <>El producto se eliminó correctamente</>}
                {msg === "okagrcont" && <>El controlador se agregó correctamente</>}
                {msg === "okeditcont" && <>El controlador se editó correctamente</>}
                {msg === "okelimcont" && <>El controlador se eliminó correctamente</>}
                {msg === "okagruser" && <>El usuario se egregó correctamente</>}
                {msg === "okedituser" && <>El usuario se editó correctamente</>}
                {msg === "okelimuser" && <>El usuario se eliminó correctamente</>}
                {msg === "okagrdong" && <>El dongle se agregó correctamente</>}
                {msg === "okeditdong" && <>El dongle se editó correctamente</>}
                {msg === "okelimdong" && <>El dongle se eliminó correctamente</>}
                {msg === "okagrpromo" && <>La promoción se agregó correctamente</>}
                {msg === "okeditpromo" && <>La promoción se editó correctamente</>}
                {msg === "okelimpromo" && <>La promoción se eliminó correctamente</>}
                {msg === "okvinculado" && <>La vinculación se realizó correctamente</>}
                {msg === "okrevinc" && <>La revinculación se realizó correctamente</>}
                {msg === "okescrito" && <>La escritura se realizó correctamente</>}
                {msg === "okescrfw" && <>El firmware se escribió correctamente</>}
                {msg === "okctco" && <>El mensaje se envió a PriDisp correctamente</>}
                <AiOutlineClose
                    className="close-icon"
                    size={20}
                    color="#000"
                    onClick={closeModal}
                    cursor={"pointer"}
                /></p>
                <div className="dist-bton">
{//(msg !== "okvinculado" && msg !== "okescrito" && msg !== "okagrprod" && msg !== "okagrcont" && msg !== "okagruser" && msg !== "okagrdong") && <button className="bton-modal" onClick={fetch}>Cerrar</button>
}
{//(msg === "okvinculado" || msg === "okescrito" || msg === "okagrprod" || msg === "okagrcont" || msg === "okagruser" || msg === "okagrdong") && <button className="bton-modal" onClick={closeModal}>Cerrar</button>
}
{<button className="bton-modal" onClick={closeModal}>Cerrar</button>}
                    </div>
                </div>
            </div>
        </div>
);
case "error":
    return (
        <div className="modal1">
            <div className="popup1">
                <div className="popup-inner1">
                    <p className="modal-text">
                {msg === "upcexists" && <>El código de barras ya existe en la base de datos</>}
                {msg === "erroragrmprod" && <>Hubo un error al agregar el producto</>}
                {msg === "erroreditprod" && <>Hubo un error al editar el producto</>}
                {msg === "errorelimprod" && <>Hubo un error al eliminar el producto</>}
                {msg === "contexists" && <>El conrtolador ya existe en la base de datos</>}
                {msg === "erroragrcont" && <>Hubo un error al agregar el controlador</>}
                {msg === "erroreditcont" && <>Hubo un error al editar el controlador</>}
                {msg === "errorelimcont" && <>Hubo un error al eliminar el controlador</>}
                {msg === "userexists" && <>El usuario ya existe en la base de datos</>}
                {msg === "erroragrmuser" && <>Hubo un error al agregar el usuario</>}
                {msg === "erroredituser" && <>Hubo un error al editar el usuario</>}
                {msg === "errorelimuser" && <>Hubo un error al eliminar el usuario</>}
                {msg === "dongexists" && <>El dongle ya existe en la base de datos</>}
                {msg === "erroragrdong" && <>Hubo un error al agregar el dongle</>}
                {msg === "erroreditdong" && <>Hubo un error al editar el dongle</>}
                {msg === "errorelimdong" && <>Hubo un error al eliminar el dongle</>}
                {msg === "erroragrmpromo" && <>Hubo un error al agregar la promoción</>}
                {msg === "erroreditpromo" && <>Hubo un error al editar la promoción</>}
                {msg === "errorelimpromo" && <>Hubo un error al eliminar la promoción</>}
                {msg === "errorescrito" && <>Hubo un error al escribir</>}
                {msg === "errorvinculado" && <>Hubo un error al vincular</>}
                {msg === "errorrevinc" && <>Hubo un error al revincular el controlador</>}
                {msg === "errorctco" && <>Hubo un error al enviar el mensaje</>}
                <AiOutlineClose
                    className="close-icon"
                    size={20}
                    color="#000"
                    onClick={closeModal}
                    cursor={"pointer"}
                /></p>
                <div className="dist-bton">
    {(msg !== "errorvinculado" && msg !== "errorescrito" && msg !== "erroragrprod" && msg !== "erroragrcont" && msg !== "erroragruser" && msg !== "erroragrdong" && msg !== "upcexists" && msg !== "contexists" && msg !== "userexists" && msg !== "dongexists" && msg !== "errorelimpromo" && msg !== "errorrevinc" && msg !== "errorctco") && <button className="bton-modal" onClick={fetch}>Cerrar</button>}
    {(msg === "errorvinculado" || msg === "errorescrito" || msg === "erroragrprod" || msg === "erroragrcont" || msg === "erroragruser" || msg === "erroragrdong" || msg === "upcexists" || msg === "contexists" || msg === "userexists" || msg === "dongexists" || msg === "errorelimpromo" || msg === "errorrevinc" || msg === "errorctco") && <button className="bton-modal" onClick={closeModal}>Cerrar</button>}
                </div>
                </div>
            </div>
        </div>
);
case "ando":
    return (
        <div className="modal1">
            <div className="popup1">
                <div className="popup-inner1">
                    <p className="modal-text">
                {msg === "eliminando" && <>Eliminando...</>}
                {msg === "vinculando" && <>Vinculando...</>}
                {msg === "revinculando" && <>Revinculando...</>}
                {msg === "escribiendo" && <>Escribiendo...</>}
                {msg === "agregando" && <>Agregando...</>}
                {msg === "editando" && <>Editando...</>}
                {msg === "cargando" && <>Cargando datos...</>}
                {msg === "enviando" && <>Enviando mensaje...</>}
                    </p>
                </div>
            </div>
        </div>
);
case "promo":
    return (
        <div className="modal">
            <div className="popup">
                <div className="popup-inner">
                  <p className="modal-text fw-7">Esta operación puede demorar varios minutos!</p>
                    <p className="modal-text">
                        {Array.from(
                            { length: contList.length }, (_, i) => (
                    //     cont["display"+(i+1)] === "d" ? <li key={"d"+i} className="nodot"></li> : 
                            <span key= {i}>
                            <li key={i+1} className="nodot">
                                <span key={"p"+i}>Implementando promoción en controlador {contList[i]}...{msgpr[i] === "okpromo"+i && <span className="fw-7">Ok</span>}{msgpr[i] === "errorpromo"+i && <span className="fw-7">Error</span>}</span><br />
                            </li>
                            <span>{ (msgpr[contList.length-1] === "okpromo"+i || msgpr[contList.length-1] === "errorpromo"+i) && <button className="bton-modal" onClick={closeLimpiaModal}>Cerrar</button>}</span>
                            </span>
                        ))}
                    </p>
                </div>
            </div>
        </div>
);
case "elimpromo":
    return (
        <div className="modal">
            <div className="popup">
                <div className="popup-inner">
                  <p className="modal-text fw-7">Esta operación puede demorar varios minutos!</p>
                    <p className="modal-text">
                        {Array.from(
                            { length: contList.length }, (_, i) => (
                    //     cont["display"+(i+1)] === "d" ? <li key={"d"+i} className="nodot"></li> : 
                            <span key= {i}>
                            <li key={i+1} className="nodot">
                                <span key={"p"+i}>Eliminando promoción en controlador {contList[i]}...{msgpr[i] === "okpromo"+i && <span className="fw-7">Ok</span>}{msgpr[i] === "errorpromo"+i && <span className="fw-7">Error</span>}</span><br />
                            </li>
                            <span>{ (msgpr[contList.length-1] === "okpromo"+i || msgpr[contList.length-1] === "errorpromo"+i) && <button className="bton-modal" onClick={closeLimpiaModal}>Cerrar</button>}</span>
                            </span>
                        ))}
                    </p>
                </div>
            </div>
        </div>
);

    default:
    break;
}
}
export default Modal;